import React, { Component } from 'react';
import PropTypes from 'prop-types';
import EdapModuleView from '../EdapModuleView';
import { Experiment } from '../Experiment';
import TrendingCard from './TrendingCard';
import Carousel from '../Carousel';
import TrendingModal from './TrendingModal';

import { FormattedMessage } from '../Intl';
import { messageKeys, getLabels } from './translations';

import {
  handleEdapClick,
  triggerEdapEvent
} from '../../utils/edap';

import {
  TRENDING_DESTINATION_LINK_CLICK,
  TRENDING_CLICK_PREV,
  TRENDING_CLICK_NEXT,
  MODULE_VIEW_EVENT_OPTIONS,
  DATEPICKER_EXPOSURE_EVENT
} from './events';

import './Trending.less';

const DEFAULT_STATE = {
  isOpen: false,
  locationQuery: '',
  url: {
    slpUrl: '',
    serpUrl: ''
  }};

class Trending extends Component {
  static propTypes = {
    tiles: PropTypes.arrayOf(PropTypes.object).isRequired
  }

  static defaultProps = {
    tiles: []
  }

  state = DEFAULT_STATE;


  // Arrow handlers
  handlePreviousClick() {
    triggerEdapEvent(TRENDING_CLICK_PREV);
  }

  handleNextClick() {
    triggerEdapEvent(TRENDING_CLICK_NEXT);
  }

  handleOnClick = (lbsUuid, value) => (evt) => {
    handleEdapClick(TRENDING_DESTINATION_LINK_CLICK, { lbsUuid })(evt);
    if (value !== null) {
      triggerEdapEvent(DATEPICKER_EXPOSURE_EVENT, { variant: value.toString() });
    }
  }

  // Modal
  handleOpenModal = (value, slpUrl, serpUrl, locationQuery) => (evt) => {
    evt.preventDefault();
    this.setState({ isOpen: true, url: { slpUrl, serpUrl }, locationQuery });
    triggerEdapEvent(DATEPICKER_EXPOSURE_EVENT, { variant: value.toString() });
  }

  handleCloseModal = () => {
    this.setState({ ...DEFAULT_STATE });
  }

  render() {
    const {
      tiles
    } = this.props;

    const { isOpen, locationQuery, url } = this.state;

    return (
      tiles && tiles.length > 0 &&
        <section className="Content__section">
          <EdapModuleView eventOptions={MODULE_VIEW_EVENT_OPTIONS}>
            <FormattedMessage id={messageKeys}>
              {(...messages) => (
                <TrendingModal
                  isOpen={isOpen}
                  locationQuery={locationQuery}
                  url={url}
                  handleClose = {this.handleCloseModal}
                  labels = {getLabels(...messages)}
                />
              )}
            </FormattedMessage>
            <Experiment name={'HA_HP_NewCarouselDatePicker_'}>
              {value =>
                (
                  <FormattedMessage id="trending.title" >
                    {trendingTitle => (
                      <Carousel
                        title = {trendingTitle}
                        onPreviousClick={this.handlePreviousClick}
                        onNextClick={this.handleNextClick}
                      >
                        {tiles.map(item => (
                          <TrendingCard key={item.lbsId} onClick={value ? this.handleOpenModal(value, item.slpUrl, item.serpUrl, item.locationQuery) : this.handleOnClick(item.lbsId, value)} {...item} />
                        ))}
                      </Carousel>
                    )
                    }
                  </FormattedMessage>
                )
              }
            </Experiment>
          </EdapModuleView>
        </section>
    );
  }
}

export default Trending;



// WEBPACK FOOTER //
// ./src/universal/components/Trending/Trending.js